import fontDisplayTypes from '../constants/font-display-types';

const getElementType = (displayName, defaultValue = 'p') => {
  switch (displayName) {
    case fontDisplayTypes.HEADING_1:
      return 'h1';
    case fontDisplayTypes.HEADING_2:
      return 'h2';
    case fontDisplayTypes.HEADING_3:
      return 'h3';
    case fontDisplayTypes.HEADING_4:
      return 'h4';
    case fontDisplayTypes.HEADING_5:
      return 'h5';
    case fontDisplayTypes.HEADING_6:
      return 'h6';
    case fontDisplayTypes.PARAGRAPH_1:
    case fontDisplayTypes.PARAGRAPH_2:
    case fontDisplayTypes.PARAGRAPH_3:
      return 'p';
    default:
      return defaultValue;
  }
};

export default getElementType;
